import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useUpdateCall } from '../../lib/api/update'
import { useGetMutateCall, getDependencyCall } from '../../lib/api/get'
import { useDependencies } from '../../store/dependencies'
import { useAuthStore } from '../../store/auth'
import { CheckInCard } from './checkInCard'

import { EditModal } from './EditModal'
import { NoDataCard } from '../../common/NoDataCard'

export const ManageStaffAttendance = ({ isLocalEnvironment, routeData }) => {
  const getCallMutation = useGetMutateCall()
  const [dates, setDates] = React.useState(null)
  const [openManage, setOpenManage] = React.useState(false)
  const [manageInd, setManageInd] = React.useState(null)
  const [setOpenActivity] = React.useState(false)
  const [activityAttenInd, setActivityAttenInd] = React.useState(null)
  const [selectedApplData, setSelectedApplData] = React.useState({
    data: { formData: [] },
  })
  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false

  const appState = useAuthStore((state) => state)
  const { setDependency } = useDependencies()
  const [updating, setUpdating] = React.useState(false)

  const getDeps = () => {
    const stateVar = { ...appState }
    if (routeData.hasDependencies) {
      routeData.dependeciesFormAPIS.map(async (api) => {
        stateVar.dependeciesFormAPIS[api] = await getDependencyCall(
          isLocalEnvironment + '/getData',
          api,
          '',
        )
        setDependency(stateVar, stateVar.role, stateVar.roleId)
      })
    }
  }

  const getOnchangeAppl = async (e) => {
    setDates(e)

    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'staffAttendance',
        params:
          '&checkInDateTime=' +
          dayjs.utc(e).format('YYYY-MM-DD HH:mm:ss') +
          '&timdatesStamp=' +
          dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss'),
        isDynamic: true,
      })
      .then((resp) => {
        setSelectedApplData(resp.formData)
      })
  }

  React.useEffect(() => {
    getDeps()
  }, [])

  const updateCallMutation = useUpdateCall()

  const onSubmit = async (data, type) => {
    setUpdating(true)
    const payload = { ...data }
    payload['attendanceType'] = type

    await updateCallMutation
      .mutateAsync({
        url: isLocalEnvironment + '/updateData',
        apiEndpoint: 'staffAttendance',
        invalidateWithParams: true,
        data: payload, // data,
        id: payload.attendanceId,
        messageTitle: 'Attendance',
        message: 'Attendance updated successfully!',
        params: '',
        noConfirmation: true,
        isDynamic: true,
      })
      .then(async () => {
        await getCallMutation
          .mutateAsync({
            apiURL: isLocalEnvironment + '/getData',
            apiEndpoint: 'staffAttendance',
            params:
              '&checkInDateTime=' +
              dayjs.utc(dates === null ? new Date() : dates).format('YYYY-MM-DD HH:mm:ss') +
              '&timdatesStamp=' +
              dayjs.utc(dates).format('YYYY-MM-DD HH:mm:ss'),
            isDynamic: true,
          })
          .then((resp) => {
            setSelectedApplData(resp.formData)
            setUpdating(false)
          })
          .catch(() => {
            setUpdating(false)
          })
      })
  }

  return (
    <>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
            <div className="trtui-row">
              <div key="date" className="trtui-col-md-12">
                <input
                  type="date"
                  className="trtui-form-control"
                  onChange={(e) => {
                    getOnchangeAppl(e.target.value, 'date')
                  }}
                  defaultValue={dates}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {getCallMutation.isLoading ? (
        <div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-none trtui-d-md-block trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '50%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
          <div
            id="status"
            className="trtui-align-items-center trtui-d-block trtui-d-md-none trtui-justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              left: '20%',
              top: '50%',
              margin: '-20px 0 0 6.4rem',
            }}
          >
            <div className="trtui-spinner-border trtui-text-primary trtui-avatar-sm" role="status">
              <span className="trtui-visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="trtui-row">
          {selectedApplData.length > 0 ? (
            selectedApplData
              .sort((a, b) => new Date(b.checkInDateTime) - new Date(a.checkInDateTime))
              .map((card, cardInd) => (
                <CheckInCard
                  key={cardInd}
                  cardData={card}
                  onSubmit={onSubmit}
                  openActivity={setOpenActivity}
                  updating={updating}
                  setActivityAttenInd={setActivityAttenInd}
                  activityAttenInd={activityAttenInd}
                  cardInd={cardInd}
                  isManage={true}
                  setManageInd={setManageInd}
                  setOpenManage={setOpenManage}
                />
              ))
          ) : (
            <NoDataCard key={isLayoutDark} isLayoutDark={isLayoutDark} />
          )}
        </div>
      )}
      {openManage && (
        <EditModal
          isLocalEnvironment={isLocalEnvironment}
          setOpenManage={setOpenManage}
          defaultData={selectedApplData[manageInd]}
        />
      )}
    </>
  )
}

ManageStaffAttendance.propTypes = {
  isLocalEnvironment: PropTypes.string,
  routeData: PropTypes.object,
}
